<template>
  <div class="bg-primary">
    <el-aside width="150px" class="h-screen">
      <div class="cursor-pointer flex justify-center">
        <InlineSvg :src="IconLogo" />
      </div>
      <el-menu
        active-text-color="#fff"
        background-color="#073763"
        class="el-menu-vertical-demo"
        :default-active="defaultActive"
        text-color="#677494"
      >
        <template v-for="item in menuItems" :key="item.index">
          <router-link v-if="!item.ceoOnly || $can('ceo', 'all')" :to="{ name: `${route.meta.type}/${item.route}` }">
            <el-menu-item :index="item.index" style="padding-left: 4px !important">
              <el-icon><component :is="item.icon" /></el-icon>
              <span>{{ item.label }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-menu>
    </el-aside>
  </div>
</template>

<script setup>
import { OfficeBuilding, DataAnalysis, User, Help, Key, ElementPlus } from '@element-plus/icons-vue'
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import IconLogo from '@/assets/svg/icon-logo.svg'

const route = useRoute()
// side bar items
const menuItems = [
  { index: '1', route: 'ap-dashboard', icon: DataAnalysis, label: 'Dashboard' },
  { index: '2', route: 'ap-roles', icon: ElementPlus, label: 'Roles' },
  { index: '3', route: 'ap-users', icon: User, label: 'Users' },
  { index: '4', route: 'ap-permissions', icon: Key, label: 'Permissions' },
  { index: '5', route: 'ap-companies', icon: OfficeBuilding, label: 'Companies', ceoOnly: true },
  { index: '6', route: 'ap-help', icon: Help, label: 'Help' },
]

const getActiveIndex = () => {
  const found = menuItems.find((item) => `${route.meta.type}/${item.route}` === route.name)
  return found ? found.index : '1'
}

const defaultActive = ref(getActiveIndex())

watch(
  () => route.name,
  () => {
    defaultActive.value = getActiveIndex()
  }
)
</script>
